import React, { useState, useEffect } from 'react';

const TestimonialCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  
  const testimonials = [
    {
        text: "Planning my trip to New Zealand was a breeze thanks to cloudmingle! The <strong>hotel suggestions</strong> were spot-on, and my stay at The Oslo Grand was absolutely fantastic. The detailed reviews helped me choose the <strong>best</strong> option, and I'll definitely be using cloudmingle for all my future travels!",
        author: "— Sarah J., New York, USA"
      },
      {
        text: "As an eco-conscious traveler, cloudmingle was a revelation! The <strong>eco-friendly hotel reviews</strong> helped me choose The Bergen Fjord Retreat, which exceeded all my expectations. Comfortable and sustainable, it was a perfect stay. Highly recommend cloudmingle to anyone seeking <strong>reliable</strong> and thoughtful hotel recommendations!",
        author: "— Emma L., Melbourne, Australia"
      },
      {
        text: "I found cloudmingle to be incredibly helpful in planning my <strong>budget-friendly trip</strong> to New Zealand. The budget hotel suggestions were perfect, and I had a great stay at Comfort Inn Oslo. Their reviews were clear and trustworthy, making it easy to book with confidence. I'm so glad I found this site!",
        author: "— David P., London, UK"
      },
      {
        text: "I love cloudmingle! Their boutique hotel reviews led me to the charming Aurora View Lodge in Tromsø, and it was exactly as described. The service was exceptional, and the character of the hotel was unmatched. I can't wait to discover more amazing hotels with cloudmingle!",
        author: "— Nora A., Amsterdam, NL"
      }
  ];

  // Auto-rotate slides every 5 seconds
  useEffect(() => {
    let interval = null;
    
    if (isAutoPlaying) {
      interval = setInterval(() => {
        setCurrentSlide((prevSlide) => (prevSlide + 1) % testimonials.length);
      }, 5000);
    }
    
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isAutoPlaying, testimonials.length]);

  // Pause auto-play on hover
  const handleMouseEnter = () => setIsAutoPlaying(false);
  const handleMouseLeave = () => setIsAutoPlaying(true);

  // Navigation functions
  const goToSlide = (index) => setCurrentSlide(index);
  
  const goToPrevSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide - 1 + testimonials.length) % testimonials.length);
  };
  
  const goToNextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % testimonials.length);
  };

  return (
    <section className="section testimonials">
      <div className="container">
        <h2 className="section-title-txt">
        What Our Guests Say About the <span>Best Hotels</span> in New Zealand
        </h2>
        <div className="row">
          <div className="col-lg-10 mx-auto">
            <div 
              className="custom-carousel" 
              onMouseEnter={handleMouseEnter} 
              onMouseLeave={handleMouseLeave}
            >
              <div className="carousel-container" style={{ position: 'relative', overflow: 'hidden' }}>
                {/* Navigation buttons */}
                <button 
                  className="carousel-arrow carousel-arrow-prev" 
                  onClick={goToPrevSlide}
                  style={{
                    position: 'absolute',
                    left: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    zIndex: 2,
                    background: 'rgba(255, 255, 255, 0.7)',
                    border: 'none',
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer'
                  }}
                >
                  &lt;
                </button>
                
                {/* Slides */}
                <div 
                  className="carousel-track" 
                  style={{
                    display: 'flex',
                    transition: 'transform 0.5s ease',
                    transform: `translateX(-${currentSlide * 100}%)`
                  }}
                >
                  {testimonials.map((testimonial, index) => (
                    <div 
                      className={`review-text carousel-slide ${index === currentSlide ? 'active' : ''}`} 
                      key={index}
                      style={{
                        minWidth: '100%',
                        padding: '30px',
                        boxSizing: 'border-box',
                        textAlign: 'center'
                      }}
                    >
                      <p dangerouslySetInnerHTML={{ __html: testimonial.text }} />
                      <h3>{testimonial.author}</h3>
                    </div>
                  ))}
                </div>
                
                <button 
                  className="carousel-arrow carousel-arrow-next" 
                  onClick={goToNextSlide}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    zIndex: 2,
                    background: 'rgba(255, 255, 255, 0.7)',
                    border: 'none',
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer'
                  }}
                >
                  &gt;
                </button>
              </div>
              
              {/* Dots navigation */}
              <div 
                className="carousel-dots"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '20px'
                }}
              >
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
                    onClick={() => goToSlide(index)}
                    style={{
                      width: '12px',
                      height: '12px',
                      borderRadius: '50%',
                      margin: '0 5px',
                      padding: 0,
                      background: index === currentSlide ? '#333' : '#ccc',
                      border: 'none',
                      cursor: 'pointer'
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialCarousel;